export const DOCUMENT_TYPES = {
  FACTURA: 'factura',
  PEDIDO: 'pedido',
  ALBARAN: 'albaran',
  PRESUPUESTO: 'presupuesto'
};

export const API_ENDPOINTS = {
  INFER_DOCUMENT: '/infer-converted-document',
  TASK_STATUS: '/task-status'
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';
  let num = value;
  if (typeof value === 'string') {
    num = parseFloat(value.replace(/\./g, '').replace(',', '.'));
  }
  if (isNaN(num)) return value;
  const fixed = num.toFixed(2);
  const [intPart, decPart] = fixed.split('.');
  const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${withThousands},${decPart}`;
};

export const parseSpanishNumber = (value) => {
  if (!value || value === '') return 0;
  if (typeof value === 'number') return value;
  const cleaned = value.replace(/\./g, '').replace(',', '.');
  return parseFloat(cleaned) || 0;
};

export const formatDate = (value) => {
  if (typeof value !== 'string') return value ?? '';
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : value;
};

export const parseDate = (value) => {
  if (typeof value !== 'string') return value;
  const m = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : value;
};
